export default "__VITE_ASSET__BOCOZP9C__"